<!-- <form (submit)="get_month_filter($event)" method="get">
	<div class="row">
		<div class="col-lg-3">
			<div class="mt-3">
				<label for="autoCompleteCampaigns" class="form-label mb-0">Search By Campaign</label>
				<ng-autocomplete
					[data]="campaignList"
					[searchKeyword]="keyword"
					placeholder="Enter Campaign Name"
					(selected)="selectEventCampaignMonth($event)"
					(inputChanged)="onChangeSearch($event)"
					(inputFocused)="onFocused($event)"
					historyIdentifier="campaignList"
					[itemTemplate]="itemTemplate"
					[notFoundTemplate]="notFoundTemplate"
				>
				</ng-autocomplete>
				<ng-template #itemTemplate let-item>
					<a [innerHTML]="item.name"></a>
				</ng-template>

				<ng-template #notFoundTemplate let-notFound>
					<div [innerHTML]="notFound"></div>
				</ng-template>

			</div>
		</div>
		<div class="col-lg-3">
			<div class="mt-3">
				<label for="autoCompleteTypes" class="form-label mb-0">Search By Type</label>
				<ng-autocomplete
					[data]="campaignTypeList"
					[searchKeyword]="keyword"
					placeholder="Enter the Type"
					(selected)="selectEventTypeMonth($event)"
					(inputChanged)="onChangeSearch($event)"
					(inputFocused)="onFocused($event)"
					historyIdentifier="campaignTypeList"
					[itemTemplate]="itemTemplate"
					[notFoundTemplate]="notFoundTemplate"
				>
				</ng-autocomplete>

				<ng-template #itemTemplate let-item>
					<a [innerHTML]="item.name"></a>
				</ng-template>

				<ng-template #notFoundTemplate let-notFound>
					<div [innerHTML]="notFound"></div>
				</ng-template>
			</div>
		</div>
		<div class="col-lg-3">
			<div class="mt-3">
				<label class="form-label mb-0">Date Range</label>
				<input name="selectMonth" id="selectMonth"  class="form-control flatpickr-input" type="text" mwlFlatpickr [altInput]="true" [convertModelValue]="true" mode="range" />
			</div>
		</div>
		<div class="col-lg-3">
			<div class="mt-3" style="padding-top: 19px;">
				<button type="submit" class="btn btn-md btn-success edit-item-btn">Search</button>
			</div>
		</div>
	</div>
</form> -->

<div class="alert alert-info text-center">
	These are the real data of leads from the previous month, on this screen
	they are shown in an informative way
</div>

<div
	*ngIf="isHidden"
	class="alert alert-warning text-center"
	[style.margin-top]="'10px'"
>
	The selected date range must be a complete month.
</div>

<div class="table-responsive table-card mt-3 mb-1">
	<table class="table">
		<thead class="bg-light">
			<tr class="bg-light text-muted">
				<th class="sort" data-sort="id">Campaign Id</th>
				<th class="sort" data-sort="id">Campaign Name</th>
				<th class="sort" data-sort="description">Type</th>
				<th class="sort" data-sort="amount">Leads / Month</th>
				<th class="sort" data-sort="amount">Leads Needed</th>
				<th class="sort" data-sort="amount">Lead Cost</th>
				<th class="sort" data-sort="amount">W1</th>
				<th class="sort" data-sort="amount">W2</th>
				<th class="sort" data-sort="amount">W3</th>
				<th class="sort" data-sort="amount">W4</th>
				<th class="sort" data-sort="amount">Total Leads</th>
				<th class="sort" data-sort="amount">Missing Leads</th>
				<th class="sort" data-sort="amount">Month Revenue</th>
				<th class="sort" data-sort="amount">Total Revenue</th>
				<th class="sort" data-sort="amount">Revenue Difference</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let data_month of ListJsListMonth$ | async">
				<td>
					<ngb-highlight
						[result]="data_month.id"
						[term]="service.searchTerm"
					></ngb-highlight>
				</td>
				<td>
					<span class="text-muted">{{ data_month.name }}</span>
				</td>
				<td>{{ data_month.type }}</td>
				<td>{{ data_month.leads_month }}</td>
				<td>{{ data_month.leads_needed }}</td>
				<td>{{ data_month.lead_cost }}</td>
				<td>{{ data_month.week_1 }}</td>
				<td>{{ data_month.week_2 }}</td>
				<td>{{ data_month.week_3 }}</td>
				<td>{{ data_month.week_4 }}</td>
				<td>{{ data_month.total_leads }}</td>
				<td>{{ data_month.diferencia }}</td>
				<td>{{ data_month.month_revenue }}</td>
				<td>{{ data_month.total_revenue }}</td>
				<td>{{ data_month.difference_revenue }}</td>
			</tr>
		</tbody>
	</table>
</div>
<div class="row justify-content-md-between align-items-md-center gy-2">
	<div class="col col-sm-6">
		<div
			class="dataTables_info mb-2"
			id="tickets-table_info"
			role="status"
			aria-live="polite"
		>
			<div *ngIf="isSearch; then thenBlock; else elseBlock"></div>
			<ng-template #thenBlock>
				Showing
				{{ servicemonthsearch.startIndex }} to
				{{ servicemonthsearch.endIndex }} of
				{{ servicemonthsearch.totalRecords }}
				entries
			</ng-template>
			<ng-template #elseBlock>
				Showing
				{{ service.startIndex }} to {{ service.endIndex }} of
				{{ service.totalRecords }}
				entries
			</ng-template>
		</div>
	</div>
	<div class="col col-sm-6">
		<div class="text-sm-right float-sm-end listjs-pagination">
			<div
				*ngIf="isSearch; then thenPagination; else elsePagination"
			></div>
			<ng-template #thenPagination>
				<ngb-pagination
					[collectionSize]="(total$ | async)!"
					[(page)]="servicemonthsearch.page"
					[pageSize]="servicemonthsearch.pageSize"
				>
				</ngb-pagination>
			</ng-template>
			<ng-template #elsePagination>
				<ngb-pagination
					[collectionSize]="(total$ | async)!"
					[(page)]="service.page"
					[pageSize]="service.pageSize"
				>
				</ngb-pagination>
			</ng-template>
		</div>
	</div>
</div>
